import { COMPLIANCE_PATH } from 'domain/compliance/constants';
import { createRoute } from 'framework/routing';

export const COMPLIANCE_REPORT_PATH = `${COMPLIANCE_PATH}/report`;

export const useComplianceReportRoute = () => {
  const baseRoutes = createRoute({ listRoute: COMPLIANCE_REPORT_PATH });

  return {
    ...baseRoutes,
  };
};
